'use client'

import React from 'react'
import Image from 'next/image'
import { Container, Flex } from '@quark/layout'
import { Text } from '@quark/typography'
import { Button } from '@quark/button'
import { Reveal } from '@quark/animation'
import isMobile from 'ismobilejs'
import styles from './secondary.module.scss'

const SecondaryCard = ({ data, setIsModalOpen, setFormSnippet }) => {
  const isMobileDevice = isMobile()?.phone
  return (
    <div className={styles.secondaryCardContainer}>
      <Reveal as="span" animationProps={{ threshold: 0.1, animationDelayMs: 100 }}>
        <Flex flexDirection={{ lg: 'column', md: 'column', sm: 'row' }} alignItems="center">
          {data?.iconUrl?.url && (
            <Image
              src={data?.iconUrl?.url}
              alt="coverage-icon"
              width={isMobileDevice ? 64 : 88}
              height={isMobileDevice ? 64 : 88}
            />
          )}
          <div>
            <div className={styles.titleText}>{data?.title}</div>
            <Text
              as="p"
              fontStyle={{ lg: 'um_text-lg/normal', md: 'um_text-base/normal', sm: 'um_text-sm/normal' }}
              color="static/Secondary-onDark"
              textAlign="center">
              {data?.subtitle || ''}
            </Text>
          </div>
        </Flex>
      </Reveal>
      <Container type="fluid" paddingTop="spacing-40" textAlign="center">
        <Reveal as="span" animationProps={{ threshold: 0.1, animationDelayMs: 400 }}>
          <Button
            type="staticOnDarkOutline"
            size="lg"
            onClick={() => {
              setIsModalOpen(true)
              setFormSnippet(data?.formSnippet)
            }}>
            <Text fontStyle="um_text-base/medium" color="static/Primary-onDark">
              {data?.actionText}
            </Text>
          </Button>
        </Reveal>
      </Container>
    </div>
  )
}

export default SecondaryCard
